import { MICROSERVICE_CONFIG } from "../../config/configs";
import { authenticatedApi } from "../api";

export const getContentReports = async (payload) => {
	const response = await authenticatedApi.get(
		`${MICROSERVICE_CONFIG.SUPERADMIN_BFF}/content-reports${
			payload ? `?${payload}` : ""
		}`
	);
	return response.data;
};

export const getContentReportById = async (reportId) => {
	const response = await authenticatedApi.get(
		`${MICROSERVICE_CONFIG.SUPERADMIN_BFF}/content-reports/${reportId}`
	);
	return response.data;
};

export const closeReport = async (payload) => {
	const { reportId, body } = payload;
	const response = await authenticatedApi.patch(
		`${MICROSERVICE_CONFIG.CUSTOMER_SUPPORT}/content-reports/${reportId}`,
		body
	);
	return response.data;
};

export const deleteComment = async (payload) => {
	const { timelineId, commentId } = payload;
	const response = await authenticatedApi.delete(
		`${MICROSERVICE_CONFIG.GIFT}/timeline/${timelineId}/comments/${commentId}`
	);
	return response.data;
};

export const getReportReasons = async (payload) => {
	const response = await authenticatedApi.get(
		`${MICROSERVICE_CONFIG.CUSTOMER_SUPPORT}/core/content-reports/reasons${
			payload ? `?${payload}` : ""
		}`
	);
	return response.data;
};

export const createReportReasons = async (payload) => {
	const response = await authenticatedApi.post(
		`${MICROSERVICE_CONFIG.CUSTOMER_SUPPORT}/core/content-reports/reasons`,
		payload
	);
	return response.data;
};

export const updateReportReasons = async (payload) => {
	const { reasonId, body } = payload;
	const response = await authenticatedApi.patch(
		`${MICROSERVICE_CONFIG.CUSTOMER_SUPPORT}/core/content-reports/reasons/${reasonId}`,
		body
	);
	return response.data;
};

export const getCoreReportTypes = async () => {
	const response = await authenticatedApi.get(
		`${MICROSERVICE_CONFIG.CUSTOMER_SUPPORT}/core/content-reports/types`
	);
	return response.data;
};
